addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-stock-table]').forEach(container => {
        const grid = container.querySelector('[data-stock-grid]');
        const search = container.querySelector('[data-stock-search]');
        const status = container.querySelector('[data-stock-status]');
        const company = container.querySelector('[data-stock-company]');
        const showZero = container.querySelector('[data-stock-show-zero]');
        if (!grid || !search || !status) return;

        const rows = Array.from(grid.tBodies[0].rows);
        const cards = Array.from(container.querySelectorAll('[data-stock-card]'));
        const totals = container.querySelectorAll('[data-stock-total]');
        const totalFields = Array.from(totals).flatMap(total =>
            ['label', 'quantity', 'weight', 'volume'].map(name => {
                const element = total.querySelector(`[data-stock-total-${name}]`);
                return { name, element };
            })
        );
        const weightFormat = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const volumeFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
        const formatNumber = (formatter, value) => formatter.format(value).replace(/[\u00a0\u202f]/g, ' ');
        const empty = container.querySelector('[data-stock-empty]');
        const contexts = rows.concat(cards);
        const barcodes = contexts.flatMap(row => Array.from(row.querySelectorAll('[data-stock-barcodes]')));
        const matches = contexts.flatMap(row => Array.from(row.querySelectorAll('[data-stock-match]')));
        const marker = new Mark(matches);
        const searchableColumns = Array.from(grid.tHead.rows[0].cells)
            .flatMap((header, index) => header.hasAttribute('data-stock-searchable') ? [index] : []);
        const table = new DataTable(grid, {
            paging: false,
            ordering: false,
            info: false,
            autoWidth: false,
            layout: {
                topStart: null,
                topEnd: null,
                bottomStart: null,
                bottomEnd: null
            },
            classes: {
                layout: {
                    row: 'dt-layout-row',
                    cell: 'dt-layout-cell',
                    tableCell: 'dt-layout-table-cell',
                    full: 'dt-layout-full'
                }
            },
            columnDefs: [
                {
                    targets: searchableColumns,
                    searchable: true,
                    type: 'string',
                    render: { filter: DataTable.util.escapeHtml }
                },
                { targets: '_all', searchable: false }
            ],
            search: { smart: false, regex: false, caseInsensitive: true },
            language: {
                emptyTable: 'Нет остатков',
                zeroRecords: 'Ничего не найдено'
            }
        });

        table.search.fixed('stock-status', (text, data, index) => {
            return !status.value || rows[index].dataset.stockState === status.value;
        });

        table.search.fixed('stock-quantity', (text, data, index) => {
            return showZero.checked || Number(rows[index].dataset.stockQuantity) !== 0;
        });

        if (company) {
            table.search.fixed('stock-company', (text, data, index) => {
                return !company.value || rows[index].dataset.stockCompany === company.value;
            });
        }

        const sync = () => {
            const query = search.value.trim();
            const filtered = !!(query || status.value || company?.value);
            const appliedRows = table.rows({ search: 'applied' }).nodes().toArray();
            // Totals are computed here only; the server renders the total row empty.
            const sum = appliedRows.reduce((result, row) => {
                const quantity = Number(row.dataset.stockQuantity);
                result.quantity += quantity;
                result.weight += Number(row.dataset.stockWeightGrams);
                result.volume += Number(row.dataset.stockVolumeCubicMillimetres);
                if (quantity !== 0 && row.dataset.stockMeasured !== '1') result.measured = false;
                return result;
            }, { quantity: 0, weight: 0, volume: 0, measured: true });
            const values = {
                label: filtered ? 'Итого по фильтру' : 'Итого',
                quantity: String(sum.quantity),
                weight: sum.measured ? `${formatNumber(weightFormat, Math.ceil(sum.weight / 100) / 10)} кг` : 'Требуется измерение',
                volume: sum.measured ? `${formatNumber(volumeFormat, Math.ceil(sum.volume / 1000000))} л` : '—'
            };
            totalFields.forEach(({ name, element }) => {
                element.textContent = values[name];
                element.classList.toggle('text-body-secondary', !sum.measured && (name === 'weight' || name === 'volume'));
            });
            window.FullioUrlState.replace({ q: query, state: status.value, company: company?.value, show_zero: showZero.checked ? '1' : '' });
            const visible = new Set(appliedRows.map(row => row.dataset.stockIndex));
            cards.forEach(card => { card.hidden = !visible.has(card.dataset.stockIndex); });
            if (empty) empty.hidden = visible.size !== 0;
            barcodes.forEach(barcode => { barcode.hidden = !query; });
            marker.unmark({
                done: () => {
                    if (query) marker.mark(query, {
                        separateWordSearch: false,
                        caseSensitive: false,
                        synonyms: { 'е': 'ё', 'и': 'й' },
                        className: 'stock-search-match'
                    });
                }
            });
        };

        table.on('draw', sync);
        search.addEventListener('input', () => table.search(search.value.trim()).draw());
        status.addEventListener('change', () => table.draw());
        showZero.addEventListener('change', () => table.draw());
        if (company) company.addEventListener('change', () => table.draw());
        const applyUrl = () => {
            window.FullioUrlState.fill(search, window.FullioUrlState.get('q'));
            window.FullioUrlState.fill(status, window.FullioUrlState.get('state'));
            if (company) window.FullioUrlState.fill(company, window.FullioUrlState.get('company'));
            showZero.checked = window.FullioUrlState.get('show_zero') === '1';
            table.search(search.value.trim()).draw();
        };
        addEventListener('hashchange', applyUrl);
        applyUrl();
    });
});
